/// <reference path="MainViewController.ts" />


class MobileViewController extends MainViewController {


}